// Deterministic seeded RNG (mulberry32). The ONLY source of randomness in the
// sim. It never touches Math.random or any wall clock, so a given seed plus a
// given command log always produces an identical run.

export class RNG {
  private s: number;

  constructor(seed: number) {
    // Coerce to uint32.
    this.s = seed >>> 0;
  }

  /** Raw next uint32 -> float in [0, 1). */
  next(): number {
    this.s = (this.s + 0x6d2b79f5) | 0;
    let t = this.s;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }

  /** Float in [min, max). */
  range(min: number, max: number): number {
    return min + (max - min) * this.next();
  }

  /** Integer in [min, max] inclusive. */
  int(min: number, max: number): number {
    return min + Math.floor(this.next() * (max - min + 1));
  }

  /** Symmetric jitter in [-mag, mag). */
  jitter(mag: number): number {
    return (this.next() * 2 - 1) * mag;
  }

  /** Serialize internal state (for save/replay snapshots). */
  getState(): number {
    return this.s >>> 0;
  }

  setState(s: number): void {
    this.s = s >>> 0;
  }
}
